export default __webpack_public_path__ + "static/media/Howitworks.83f25009.png";